/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { OrgComplianceSettingsResponseCandidateNameDisplayMode } from './orgComplianceSettingsResponseCandidateNameDisplayMode';

/**
 * Read shape for org-level privacy/compliance settings.
 */
export interface OrgComplianceSettingsResponse {
  org_id: string;
  candidate_name_display_mode?: OrgComplianceSettingsResponseCandidateNameDisplayMode;
  show_candidate_photos?: boolean;
  show_profile_highlights?: boolean;
  show_insights_gender?: boolean;
  /**
     * @items.minLength 1
     * @items.maxLength 128
     */
  hidden_profile_highlight_ids?: string[];
  updated_at?: string | null;
  updated_by_user_id?: string | null;
}
